import { useState, useEffect } from "react";
import './Progetti.css';
import api from "../../api.js";
import axios from 'axios';
import ConfirmModal from "../ConfirmModal/ConfirmModal.js";

export default function Progetti() {
  const [progetti, setProgetti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [inizialProject, setInizialProject] = useState([]);
  const [filterQuery, setFilterQuery] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    axios.post(`${api()}/projects/getProjects`, {}, {
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then((response) => {
        let projects = response.data || [];
        projects.forEach((element, i) => {
          element.id = i + 1;
        });
        setProgetti(projects);
        setInizialProject(projects);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="progetti-loading">
        <div className="spinner"></div>
        <p>Caricamento progetti in corso...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="progetti-error-box">
        <h3>Si è verificato un errore</h3>
        <p>{error.message}</p>
        <button onClick={() => window.location.reload()} className="btn-retry">Riprova</button>
      </div>
    );
  }

  const requestDelete = (p) => {
    setDeleteTarget({
      id: p.id,
      _id: p._id,
      name: p.title || p.progetto || `Progetto #${p.id}`
    });
  };

  const confirmDelete = () => {
    if (!deleteTarget) return;
    const { id, _id } = deleteTarget;
    deleteRow(id, _id);
    setDeleteTarget(null);
  };

  const deleteRow = (id, _id) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((progetto) => progetto.id === id);
    if (index !== -1) {
      progettiCopy.splice(index, 1);
      axios.post(`${api()}/projects/deleteProject`, {
        id: _id,
        headers: {
          authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then((response) => console.log(response))
      .catch((err) => console.error(err));

      setProgetti(progettiCopy);
      setInizialProject(progettiCopy);
    }
  };

  const addProgetto = () => {
    const progettiCopy = [...progetti];
    const newId = progettiCopy.length > 0 ? Math.max(...progettiCopy.map(p => p.id)) + 1 : 1;
    const newProgetto = {
      id: newId,
      title: "progetto" + newId,
      tags: "tag1, tag2",
      company: 'company name',
      progetto: 'nome progetto',
      email: 'email di riferimento',
      website: 'www.example.com',
      hosting: 'hosting example',
      codice: 'github',
      description: 'description example',
      note: 'note example',
      modify: true,
      new: true,
      createdBy: localStorage.getItem('email'),
      edit: false
    };
    const updated = [newProgetto, ...progettiCopy];
    setProgetti(updated);
    setInizialProject(updated);
  };

  const esportTabella = () => {
    const progettiCopy = [...progetti];
    const progettiExport = progettiCopy.map(({ id, title, tags, company, progetto, email, website, hosting, codice, description, note }) => 
      ({ id, title, tags, company, progetto, email, website, hosting, codice, description, note })
    );
    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(progettiExport, null, 2));
    const downloadAnchor = document.createElement('a');
    downloadAnchor.setAttribute("href", dataStr);
    downloadAnchor.setAttribute("download", `progetti_export_${new Date().toISOString().slice(0,10)}.json`);
    document.body.appendChild(downloadAnchor);
    downloadAnchor.click();
    downloadAnchor.remove();
  };

  const changeVal = (id, field, value) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((progetto) => progetto.id === id);
    if (index !== -1) {
      progettiCopy[index][field] = value;
      setProgetti(progettiCopy);
      setInizialProject(progettiCopy);
    }
  };

  const modifyRow = (id) => {
    const progettiCopy = [...progetti];
    const index = progettiCopy.findIndex((progetto) => progetto.id === id);
    if (index !== -1) {
      progettiCopy[index].modify = !progettiCopy[index].modify;
      progettiCopy[index].edit = true;
      setProgetti(progettiCopy);
      setInizialProject(progettiCopy);
    }
  };

  const saveDataFromApi = (data, path) => {
    axios.post(`${api()}/projects/${path}`, {
      data: data,
      headers: {
        authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
    .then((response) => {
      setLoading(false);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    })
    .catch((err) => {
      console.error(err);
      setError(err);
      setLoading(false);
    });
  };

  const saveProject = () => {
    const progettiCopy = [...progetti];
    const progettiNew = [];
    const progettiModify = [];

    progettiCopy.forEach((p) => {
      if (p.new) {
        const { id, title, tags, company, progetto, email, website, hosting, codice, description, note, createdBy } = p;
        progettiNew.push({ id, title, tags, company, progetto, email, website, hosting, codice, description, note, createdBy });
      } else if (p.edit) {
        const { _id, id, title, tags, company, progetto, email, website, hosting, codice, description, note } = p;
        progettiModify.push({ _id, id, title, tags, company, progetto, email, website, hosting, codice, description, note });
      }
    });

    if (progettiNew.length > 0) {
      saveDataFromApi(progettiNew, 'createProject');
    }
    if (progettiModify.length > 0) {
      saveDataFromApi(progettiModify, 'updateProject');
    }
  };

  const filterRow = (value) => {
    setFilterQuery(value);
    const progettiCopy = [...inizialProject];
    if (!value.trim()) {
      setProgetti(progettiCopy);
    } else {
      const q = value.toLowerCase();
      const progettiFilter = progettiCopy.filter((p) => {
        return (
          (p.id && p.id.toString().includes(q)) ||
          (p.title && p.title.toLowerCase().includes(q)) ||
          (p.tags && Array.isArray(p.tags) ? p.tags.join(' ').toLowerCase().includes(q) : p.tags?.toLowerCase().includes(q)) ||
          (p.company && p.company.toLowerCase().includes(q)) ||
          (p.progetto && p.progetto.toLowerCase().includes(q)) ||
          (p.email && p.email.toLowerCase().includes(q)) ||
          (p.website && p.website.toLowerCase().includes(q)) ||
          (p.hosting && p.hosting.toLowerCase().includes(q)) ||
          (p.codice && p.codice.toLowerCase().includes(q)) ||
          (p.description && p.description.toLowerCase().includes(q)) ||
          (p.note && p.note.toLowerCase().includes(q))
        );
      });
      setProgetti(progettiFilter);
    }
  };

  const renderTags = (tags) => {
    if (!tags) return null;
    const tagList = Array.isArray(tags) ? tags : tags.split(',').map(t => t.trim());
    return (
      <div className="tag-list">
        {tagList.map((tag, idx) => (
          <span key={idx} className="tag-chip">{tag}</span>
        ))}
      </div>
    );
  };

  return (
    <div id="progetti" className="progetti-page">
      <div className="page-header">
        <div className="header-title">
          <h1>Progetti</h1>
          <span className="count-badge">{progetti.length} Totali</span>
        </div>
      </div>

      <div className="progetti-action-bar progetti-cont-btn">
        <button onClick={addProgetto} className='progetti-btn-add btn-action primary'>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          + Aggiungi Progetto
        </button>
        
        <button onClick={esportTabella} className='btn-action secondary'>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
          Esporta JSON
        </button>
        
        <button className='btn-action success' onClick={saveProject}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
          Salva Modifiche
        </button>

        <div className="search-box">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
          <input 
            type="text" 
            className="find" 
            placeholder="Filtra progetti..." 
            value={filterQuery}
            onChange={(e) => filterRow(e.target.value)}
          />
        </div>
      </div>

      {saveSuccess && (
        <div className="toast-success">
          ✓ Progetti salvati con successo!
        </div>
      )}

      <div className="progetti-table-card">
        <div className="progetti-table-wrapper">
          <table className="progetti-table">
            <thead>
              <tr>
                <th style={{ width: '90px' }}>Modifica</th>
                <th style={{ width: '100px' }}>Elimina</th>
                <th style={{ width: '50px' }}>ID</th>
                <th>Titolo</th>
                <th>Tags</th>
                <th>Azienda</th>
                <th>Progetto</th>
                <th>Email Ref.</th>
                <th>Sito Web</th>
                <th>Hosting</th>
                <th>Codice</th>
                <th>Descrizione</th>
                <th>Note</th>
              </tr>
            </thead>
            <tbody>
              {progetti.length === 0 ? (
                <tr>
                  <td colSpan="13" className="empty-table">Nessun progetto trovato</td>
                </tr>
              ) : (
                progetti.map((p) => (
                  <tr key={p.id} className={p.modify ? 'row-editing' : ''}>
                    <td>
                      <button 
                        onClick={() => modifyRow(p.id)} 
                        className={`btn-table-edit ${p.modify ? 'editing' : ''}`}
                      >
                        {p.modify ? 'Fatto' : 'Edit'}
                      </button>
                    </td>

                    <td>
                      <button 
                        onClick={() => requestDelete(p)} 
                        className="btn-table-del-btn" 
                        title="Elimina Progetto"
                      >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        Elimina
                      </button>
                    </td>

                    <td className="cell-id">#{p.id}</td>

                    {p.modify ? (
                      <>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'title', e.target.value)} value={p.title || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'tags', e.target.value)} value={p.tags || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'company', e.target.value)} value={p.company || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'progetto', e.target.value)} value={p.progetto || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'email', e.target.value)} value={p.email || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'website', e.target.value)} value={p.website || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'hosting', e.target.value)} value={p.hosting || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'codice', e.target.value)} value={p.codice || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'description', e.target.value)} value={p.description || ''} /></td>
                        <td><input type="text" className="table-input" onChange={(e) => changeVal(p.id, 'note', e.target.value)} value={p.note || ''} /></td>
                      </>
                    ) : (
                      <>
                        <td className="cell-title">{p.title}</td>
                        <td>{renderTags(p.tags)}</td>
                        <td>{p.company}</td>
                        <td className="cell-bold">{p.progetto}</td>
                        <td className="cell-muted">{p.email}</td>
                        <td>
                          {p.website ? (
                            <a href={p.website.startsWith('http') ? p.website : `https://${p.website}`} target="_blank" rel="noreferrer" className="link-ext">
                              {p.website}
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                            </a>
                          ) : '-'}
                        </td>
                        <td><span className="badge-subtle">{p.hosting || '-'}</span></td>
                        <td><span className="code-tag">{p.codice || '-'}</span></td>
                        <td className="cell-desc" title={p.description}>{p.description}</td>
                        <td className="cell-desc" title={p.note}>{p.note}</td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <ConfirmModal 
        isOpen={!!deleteTarget}
        title="Conferma Eliminazione Progetto"
        message={`Sei sicuro di voler eliminare il progetto "${deleteTarget?.name}"? Questa azione rimuoverà definitivamente il progetto dal sistema.`}
        onConfirm={confirmDelete}
        onCancel={() => setDeleteTarget(null)}
      />
    </div>
  );
}